(ns teamoesterreich.user-mode.wana-help.helping
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent.core :as r]
    [teamoesterreich.firebase.remote-config :as remote-config]
    [teamoesterreich.user-mode.actions :as a]

    [teamoesterreich.user-mode.wana-help.kat.panel-kat :as panel-kat]
    [teamoesterreich.user-mode.wana-help.lebensretter.panel-lebensretter :as panel-lebensretter]
    [teamoesterreich.user-mode.wana-help.neighbor.panel-neighbor :as panel-neighbor]
    [teamoesterreich.user-mode.wana-help.nokat.panel-nokat :as panel-nokat]
    [teamoesterreich.user-mode.wana-help.online.panel-online :as panel-online]
    [teamoesterreich.user-mode.wana-help.tafel.panel-tafel :as panel-tafel]
    ))


(defn get-it []

  (let [!login-state (r/atom {:step 0 :type :undefined :consent false})]

    [mui/grid
     {:container true
      :direction "row"
      :justify   "center"
      :style     {:marginTop "45px"}
      }

     [mui/grid
      {:item true
       :xs   12
       }

      [mui/grid
       {:container  true
        :direction  "row"
        :justify    "center"
        :alignItems "stretch"
        :spacing    3
        }

       (when (remote-config/get-boolean "help_card_emergency") (panel-kat/get-it))
       (when (remote-config/get-boolean "help_card_no_emergency") (panel-nokat/get-it))
       (when (remote-config/get-boolean "help_card_lebensretter") (panel-lebensretter/get-it))
       (when (remote-config/get-boolean "help_card_online") (panel-online/get-it))
       (when (remote-config/get-boolean "help_card_tafel") (panel-tafel/get-it))
       (when (remote-config/get-boolean "help_card_neighbourhood") (panel-neighbor/get-it))

       ]]





     [mui/grid
      {:container false
       :item      true
       :lg        8
       :xs        12
       :style     {:padding "15px"}
       }
      [mui/button
       {:variant   "contained"
        :class     "bottom-button"
        :onClick   #(a/set-page-back)
        :startIcon (r/as-element [keyboard-arrow-left])
        }
       "Zurück"]]]

    ))